export const deduplicateWording = (phrase: string, word: string) => {
  const includesWord = new RegExp(`${word}`, 'i');

  if (includesWord.test(phrase)) {
    return phrase;
  }

  return `${word} ${phrase}`;
};
